// Modules 
import io from 'socket.io-client';

const Socket = (query_object) => {
  // Detect protocol actual del navegador
  const isHttps = window.location.protocol === 'https:';

  // Obtenemos la base del servidor (sin /api)
  const server = process.env.REACT_APP_API_URL.split('/api')[0];

  // Conectamos al socket
  const socket = io(server, {
    transports: isHttps ? ['websocket', 'polling'] : ['polling'], // solo usa websocket si estás en HTTPS
    query: query_object,
  });

  return socket;
};

export default Socket;